(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["usize-script"] && !Shopify.designMode) return;
  try {
    // Guard: avoid double listeners when snippet is included twice.
  if (!window.__usizyThemeListenerInstalled) {
    window.__usizyThemeListenerInstalled = true;

    const dedupeSpinnersInShadowRoot = (shadowRoot) => {
      if (!shadowRoot) return;
      const spinners = shadowRoot.querySelectorAll('div.spinner');
      if (spinners.length <= 1) return;
      spinners.forEach((node, index) => {
        if (index === spinners.length - 1) return;
        node.remove();
      });
    };

    const dedupeLightbox = () => {
      const nodes = document.querySelectorAll('#usizy-lightbox');
      if (nodes.length <= 1) return;
      nodes.forEach((node, index) => {
        if (index === nodes.length - 1) return;
        node.remove();
      });
    };

    // Usizy may inject the lightbox more than once if initialized twice.
    window.addEventListener('message', (e) => {
      if (e?.data?.subject === 'USIZY_WC_CONNECTED') {
        const usizyWidget = document.getElementById(e.data.btid);
        const shadowRoot = usizyWidget?.shadowRoot;
        if (!shadowRoot) return;

        dedupeSpinnersInShadowRoot(shadowRoot);

        const link = shadowRoot.getElementById('info-window');
        const linkText = shadowRoot.getElementById('size-text');
        const icon = shadowRoot.querySelector('svg');
        const size = shadowRoot.getElementById('size-auto');

        link?.setAttribute('part', 'link');
        linkText?.setAttribute('part', 'text');
        icon?.setAttribute('part', 'icon');
        size?.setAttribute('part', 'size');

        const row = usizyWidget.closest('.card__variant-option--usizy, .card-quick-add__variant-option--usizy');
        if (row && link) {
          const closeParentQuickAdd = () => {
            const quickAdd = row.closest('product-custom-quick-add');
            if (quickAdd?.close) quickAdd.close();
          };
          row.addEventListener('click', (e) => {
            if (!e.target.closest('usizy-wc')) {
              closeParentQuickAdd();
              link.click();
            }
          });
          row.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              closeParentQuickAdd();
              link.click();
            }
          });
        }
        if (row && size) {
          const updateRowState = () => {
            row.classList.toggle('has-size', size.textContent.trim().length > 0);
          };
          updateRowState();
          const observer = new MutationObserver(updateRowState);
          observer.observe(shadowRoot, {
            childList: true,
            subtree: true,
            characterData: true,
          });

          // Usizy may append multiple spinners inside shadowRoot on visibility changes (e.g. inside <dialog>).
          // Deduplicate on any shadow DOM mutation to prevent accumulation.
          const spinnerObserver = new MutationObserver(() => dedupeSpinnersInShadowRoot(shadowRoot));
          spinnerObserver.observe(shadowRoot, { childList: true, subtree: true });

          new MutationObserver(() => {
            if (!document.contains(usizyWidget)) {
              observer.disconnect();
              spinnerObserver.disconnect();
            }
          }).observe(document.body, { childList: true, subtree: true });
        }

        dedupeLightbox();
      }
    });

    // Also dedupe after load in case lightbox is injected early.
    window.addEventListener('load', () => setTimeout(dedupeLightbox, 0), { once: true });
  }
  } catch(e) { console.error(e); }
})();

})();
